import { useOutletContext } from 'react-router-dom';
import { MobileNotificationsContextType } from '../mobile-notifications';
import { NotificationsList } from '../notifications-list/notifications-list';

export const MobileNotificationsAll = () => {
  const { handleRemoveNotification, notifications, isLoading } =
    useOutletContext<MobileNotificationsContextType>();

  if (isLoading) return null;

  return (
    <NotificationsList
      notifications={notifications}
      handleRemoveNotification={handleRemoveNotification}
    />
  );
};
